import React from "react";
import * as facilityAccountingReferenceApi from "api/rpc/2024-04/facilityAdmin/facility/accounting";
import AccountingReferenceNew from "pages/secure/shared/settings/accountingReferences/AccountingReferenceNew";

export default function FacilityAccountingReferenceNew() {
  return <AccountingReferenceNew api={facilityAccountingReferenceApi} />;
}
